import * as React from 'react'
import './LinkFilters.scss'
import moment from 'moment';
import { ActionType, CHAINTYPES, reducerStoreType, linkFilterType, ROLES } from "../../reducers/types";
import FormControl from "@material-ui/core/FormControl";
import Select from '@material-ui/core/Select';
import { MyInput, Label, MyMenuItem } from "../../components/CustomUIComp/CustomFormElem";
import Grid from "@material-ui/core/Grid";
import { injectIntl, IntlShape } from "react-intl";
import Loadable from "react-loadable";
import 'react-dates/lib/css/_datepicker.css';
import { Dispatch } from "redux";
import { connect } from "react-redux";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  filters: linkFilterType,
  chainType: CHAINTYPES,
  role: ROLES,
  intl: IntlShape
}

interface IState {
  focusedInput: string | null
}

const LoadableComponent = Loadable({
  loader: () => import('./LinkDatePicker'),
  loading() { return (<div>loading...</div>) },
});

class LinkFilters extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      focusedInput: null
    }
  }

  handleStatusChange = (settleStatus: any) => {
    this.props.dispatch({ type: 'SET_LINK_STATUS', payload: settleStatus })
  }

  onConfirm = () => {
    this.props.dispatch({ type: 'SEARCH_LINK', payload: {} })
  }

  onClear = () => {
    this.props.dispatch({ type: 'CLEAR_LINK_FILTERS', payload: {} })
    this.props.dispatch({ type: 'RELOAD_LINK', payload: {} })
  }

  handleDateChange = (value: any) => {
    let start = ''
    let end = ''
    if (value.startDate) {
      start = moment(value.startDate).format("YYYY-MM-DD")
    }
    if (value.endDate) {
      end = moment(value.endDate).format("YYYY-MM-DD")
    }
    this.props.dispatch({ type: 'SET_LINK_DATE', payload: { startDate: start, endDate: end } })
  }
  handleFocuseChange = (value: any) => {
    this.setState({ focusedInput: value })
  }

  getSettleStatus = () => {
    let { intl } = this.props
    return [
      { value: -1, label: intl.formatMessage({ id: 'all' }) },
      { value: 1, label: intl.formatMessage({ id: 'paid' }) },
      { value: 0, label: intl.formatMessage({ id: 'unpaid' }) }
    ]
  }

  public render() {
    const settlementOptions = this.getSettleStatus()
    let { filters, intl } = this.props
    return (
      <div className="OrderFilters">
        <Grid container spacing={2}>
          <Grid item>
            <LoadableComponent filters={filters}
              handleDateChange={this.handleDateChange}
              focusedInput={this.state.focusedInput}
              handleFocuseChange={this.handleFocuseChange} />
          </Grid>
          <Grid item>
            <div className="filterItem">
              <FormControl className="formControl">
                <Label shrink htmlFor="settle-status-select">
                  {intl.formatMessage({ id: 'transactionStatus' })}
                </Label>
                <Select
                  value={filters.status}
                  onChange={
                    (event: React.ChangeEvent<{ name?: string; value: any }>) => this.handleStatusChange({
                      settleStatus: event.target.value
                    })
                  }
                  input={<MyInput width={130} labelmargin={18} border="none" id="settle-status-select" name="settleStatus" />}
                >
                  {
                    settlementOptions.map((settleStatus, i) => {
                      return <MyMenuItem key={`settle-statues-${settleStatus.value}`}
                        value={settleStatus.value}>{settleStatus.label}</MyMenuItem>
                    })
                  }
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
        <div className="buttons">
          <button className="primaryButton"
            onClick={this.onConfirm}>{intl.formatMessage({ id: 'query' })}</button>
          <button className="whiteButton"
            onClick={this.onClear}>{intl.formatMessage({ id: 'clear' })}</button>
        </div>
      </div>
    );
  }
}

export default injectIntl(connect((state: reducerStoreType) => {
  return {
    filters: state.searchLink.linkFilters,
    chainType: state.merchant.merchantInfo.chainType,
    role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE
  }
})(LinkFilters))